import { analyzePrivClient } from "src/services/api";

class ReportManagerService {
  constructor() {}

  // Recupera os dados do gerenciador de relatórios
  getReportData(surveyId, clientId) {
    const resourceLocation = `/pesquisa/resultados/relatorio/cliente/${ clientId }/pesquisa/${ surveyId }`;
    const result = analyzePrivClient.get(resourceLocation);
  
    return result;
  }

  // Persiste a imagem de capa do relatório e recupera o URL
  persistReportCoverImage(imageFile) {
    const resourceLocation = '/imagem/relatorio/upload';

    const formData = new FormData();
    formData.append("file", imageFile);

    return analyzePrivClient.post(resourceLocation, formData);
  }
}


export const reportManagerService = new ReportManagerService();